<mat-progress-bar 
  [mode]="mode"
  [value]="value"
  [bufferValue]="bufferValue"
  [color]="color">
</mat-progress-bar> 